import "core-js/modules/es6.array.sort.js";
import Table from "./Table";
import Column from "./Column";
import ColumnGroup from "./ColumnGroup";
import multiSelect from './lib/multiSelect';
import singleSelect from './lib/singleSelect';
import bigData from './lib/bigData';
import dragColumn from './lib/dragColumn';
import filterColumn from './lib/filterColumn';
import sort from './lib/sort';
import sum from './lib/sum';
Table.multiSelect = multiSelect;
Table.singleSelect = singleSelect;
Table.bigData = bigData;
Table.dragColumn = dragColumn;
Table.filterColumn = filterColumn;
Table.sort = sort;
Table.sum = sum;
Table.Column = Column;
Table.ColumnGroup = ColumnGroup;
export default Table;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-table/src/index.js